<div class="collab-banner sticky-header-banner banner-sec relative">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <div class="mx-auto whats-new-label banner-wts-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph secondary-gradient-text">
                        {{'podcasts.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mx-auto secondary-gradient-text">{{'podcasts.banner.title' | translate}}</h1>
                <p class="paragraph-global-text mw-800 text-whitish-gray">{{'podcasts.banner.description' | translate}}</p>
                <div class="mt-5 mb-5 mx-auto button-container">                    
                    <a class="save-btn btn cfa" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">{{'podcasts.banner.btnText' | translate}}   </a>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{'podcasts.broadCasts.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-650">{{'podcasts.broadCasts.description' | translate}}</p>
        </div>

        <div class="px-3 mb-5">
            <input type="search" class="search-icon form-control podcast-search" placeholder="{{'podcasts.broadCasts.search' | translate}}"
             [(ngModel)]="searchText" (ngModelChange)="searchPodcasts()">
        </div>
  
        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let video of podcasts">
                <div class="card podcast-card justify-content-between card-hover-effect">
                   <div>
                        <div class="podcast-img w-100">
                            <img class="thumbnail-img" [src]="video.thumbnail" [alt]="video.title">
                        </div>
                        <div class="podcast-card-content-sec">
                            <img class="play-video-icon" src="../../../assets/icons/podcast/play-blue-icon.svg" alt="">
                            <p class="paragraph-global-text sub-heading-color">{{video.presenter}}</p>
                            <h4 class="heading-four desc-3 mb-3">{{video.title}}</h4>
                            <p class="paragraph-global-text sub-head-paragraph mb-0"> <i class="pi pi-clock mr-2"></i> {{video.duration}}</p>
                        </div>
                   </div>
                   <a [routerLink]="'/en/podcasts/' + video.id" class="video-btn">View video clips</a>
                </div>
             </div>
        </div>
    </div>
</div>



<div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
  <div class="container z-index">
      <div class="sec-title text-center">
          <h2 class="heading-one text-white mx-auto">{{'podcasts.cfa.title' | translate}} </h2>
          <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'podcasts.cfa.description' | translate}}</p>

          <div class="button-container mt-4">
              <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                {{'podcasts.cfa.btnText' | translate}}
              </a>
          </div>
      </div>
  </div>
</div>